import { apiGetClient, apiPostClient, apiPutClient, apiPostImageClient } from "../../api/apiSvtAdmin";
import { toast } from 'react-toastify';
import i18n from "i18next";
const t = i18n.t.bind(i18n);

export const getAllDistributionList = async () => {
    try {
        const response = await apiGetClient.get("foundation/distribution-lists");
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, { position: "top-center" });
        return null;
    }
};

export const createNewDistributionList = async (data) => {
    try {
        const response = await apiPostClient.post("foundation/distribution-lists", data);
        if (response?.data?.data) {
            toast.success(t("distributionListCreatedSuccess", { title: data?.title }), { position: "top-center" });
            return response.data;
        } else {
            toast.error(t("unexpectedResponseStructure"), { position: "top-center" });
            return null;
        }
    } catch (error) {
        let errorData = error.response?.data;
        if (errorData?.errors) {
            Object.keys(errorData.errors).forEach((field) => {
                errorData.errors[field].forEach((message) => {
                    toast.error(message, { position: "top-center" });
                });
            });
        } else {
            toast.error(error.response?.data?.error || "An error occurred.", { position: "top-center" });
        }
        return null;
    }
};

export const updateDistributionList = async (data, id) => {
    try {
        const response = await apiPutClient.put(`foundation/distribution-lists/${id}`, data);
    toast.success(t("distributionListUpdatedSuccess", { title: data?.title }), { position: "top-center" });
        return response.data;
    } catch (error) {
        let errorData = error.response.data;
        if (errorData?.errors) {
            Object.keys(errorData?.errors).forEach(field => {
                errorData?.errors[field].forEach(message => {
                    toast.error(message, { position: "top-center" });
                });
            });
        } else {
            toast.error(error.response.data?.error, { position: "top-center" });
        }
        return null;
    }
};


export const revokeDistributionListEmail = async (distributionListId, data) => {
    try {
        const response = await apiPutClient.put(
            `/foundation/distribution-lists/${distributionListId}/revoke-email`,
            data,
            // {
            //   params: {
            //     email: email, 
            //   },
            // }
        );
        return response.data;
    } catch (error) {
        const errorData = error.response?.data;
        if (errorData?.errors) {
            Object.keys(errorData.errors).forEach((field) => {
                errorData.errors[field].forEach((message) => {
                    toast.error(message, { position: "top-center" });
                });
            });
        } else {
            toast.error(error.response?.data?.error || "Failed to revoke member.", {
                position: "top-center",
            });
        }
        return null;
    }
};

export const addNewNotification = async (data) => {
    try {
        const response = await apiPostImageClient.post("email/notify", data);
    toast.success(t("notificationSentSuccess"), { position: "top-center" });
        return response.data;
    } catch (error) {
        let errorData = error.response.data;
        if (errorData?.errors) {
            Object.keys(errorData?.errors).forEach(field => {
                errorData?.errors[field].forEach(message => {
                    toast.error(message, { position: "top-center" });
                });
            });
        } else {
            toast.error(error.response.data?.error, { position: "top-center" });
        }
        return null;
    }
};